// src/redux-saga/reducers/testCaseReducer.js

import {
  FETCH_TESTCASES_REQUEST,
  FETCH_TESTCASES_SUCCESS,
  FETCH_TESTCASES_FAILURE,
  CREATE_TESTCASE_REQUEST,
  CREATE_TESTCASE_SUCCESS,
  CREATE_TESTCASE_FAILURE,
  UPDATE_TESTCASE_REQUEST,
  UPDATE_TESTCASE_SUCCESS,
  UPDATE_TESTCASE_FAILURE,
  DELETE_TESTCASE_REQUEST,
  DELETE_TESTCASE_SUCCESS,
  DELETE_TESTCASE_FAILURE,
  GENERATE_TESTCASE_REQUEST,
  GENERATE_TESTCASE_SUCCESS,
  GENERATE_TESTCASE_FAILURE,
  PROCESS_TESTCASE_REQUEST,
  PROCESS_TESTCASE_SUCCESS,
  PROCESS_TESTCASE_FAILURE
} from '../actions/testCaseAction';

const initialState = {
  testCases: [],
  loading: false,
  error: null,
  processModal: {
    open: false,
    passed: 0,
    failed: 0,
    undetermined: 0,
    failedCases: [],
  },
};


const testCaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TESTCASES_REQUEST:
    case CREATE_TESTCASE_REQUEST:
    case UPDATE_TESTCASE_REQUEST:
    case DELETE_TESTCASE_REQUEST:
    case GENERATE_TESTCASE_REQUEST:
    case PROCESS_TESTCASE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TESTCASES_SUCCESS:
      return { ...state, loading: false, testCases: action.payload };

    case CREATE_TESTCASE_SUCCESS:
      return { ...state, loading: false, testCases: [...state.testCases, action.payload] };

    case UPDATE_TESTCASE_SUCCESS:
      return {
        ...state,
        loading: false,
        testCases: state.testCases.map((testCase) =>
          testCase.id === action.payload.id ? action.payload : testCase
        ),
      };

    case DELETE_TESTCASE_SUCCESS:
      return {
        ...state,
        loading: false,
        testCases: state.testCases.filter((testCase) => testCase.id !== action.payload),
      };
    case GENERATE_TESTCASE_SUCCESS:
      return {
        ...state,
        loading: false,
        testCases: [...state.testCases, action.payload],
      };
    case PROCESS_TESTCASE_SUCCESS:
      return {
        ...state,
        loading: false,
        testCases: [...state.testCases, action.payload],
      };

    case FETCH_TESTCASES_FAILURE:
    case CREATE_TESTCASE_FAILURE:
    case UPDATE_TESTCASE_FAILURE:
    case DELETE_TESTCASE_FAILURE:
    case GENERATE_TESTCASE_FAILURE:
    case PROCESS_TESTCASE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case 'SET_PROCESS_MODAL_DATA':
      return {
        ...state,
        processModal: action.payload,
      };

    default:
      return state;
  }

};

export default testCaseReducer;